import type { ReactNode } from 'react';
import { IconButton, type IconButtonProps } from '@mui/material';
import { useCollapsibleGroup } from '@/components/common/collapsible-group.context';
import { useTranslations } from '@/i18n/use-translations';

const defaultSx = {
  'p': 0.25,
  'borderRadius': 1,
  '&:hover': { backgroundColor: 'action.hover' },
} as const;

/**
 * Leading invitation-status control: expands/collapses the contributor row
 * (same pattern as media status icons). Profile opens from avatar / overflow / review icon.
 */
export function ContributorInvitationExpandButton({
  itemId,
  color,
  children,
  sx = defaultSx,
}: {
  itemId: string;
  color?: IconButtonProps['color'];
  children: ReactNode;
  sx?: IconButtonProps['sx'];
}) {
  const t = useTranslations();
  const groupContext = useCollapsibleGroup();
  const expanded = groupContext?.expandedId === itemId;

  return (
    <IconButton
      type="button"
      color={color}
      aria-label={expanded ? t('common.collapseInfo') : t('common.expandInfo')}
      aria-expanded={expanded}
      disabled={!groupContext}
      onClick={(e) => {
        e.stopPropagation();
        groupContext?.toggleExpanded(itemId);
      }}
      sx={sx}
    >
      {children}
    </IconButton>
  );
}
